import { SVGProps, Ref, forwardRef } from 'react';

export const FlaskFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M5.333 9.367c.933 0 1.527.382 2.28.883.749.499 1.659 1.117 3.054 1.117 1.185 0 2.468-.447 3.485-.904 1.179 1.883 1.646 3.07 1.152 4.061q-.03.06-.062.116C14.478 16 12.318 16 8 16s-6.478 0-7.242-1.36l-.062-.116c-.5-1.001-.017-2.203 1.19-4.123l.21-.103c1.024-.49 2.238-.93 3.237-.93"
                fill="currentColor"
            />
            <path
                d="M11.414.007a1.517 1.517 0 0 1 .257 2.969l-.257.07v3.336q.435.625.95 1.385.55.81 1.014 1.505c-.896.386-1.878.695-2.71.695-.934 0-1.528-.382-2.28-.883-.75-.499-1.66-1.117-3.055-1.117-.683 0-1.4.149-2.078.362l.38-.562q.516-.76.951-1.385V3.047l-.257-.071a1.516 1.516 0 0 1 .257-2.97V0h6.828z"
                fill="currentColor"
            />
        </g>
    </svg>
));
FlaskFilledSize16Glyph.displayName = 'FlaskFilledSize16Glyph';
